import React, { useState, useEffect, useRef } from "react";
//redux
import { connect } from "react-redux";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
import Dialog from '../../../../components/Backdrops/Dialog';
import { useLocation } from "react-router-dom";
//service
import plusXMiceIdService from "../../../../utils/services/accreditation/plusXMiceId";
import adminUserService from "../../../../utils/services/accreditation/adminUser";
import scheduleService from "../../../../utils/services/accreditation/schedule";
import PlusXMiceIdModel from '../../../../utils/models/PlusXMiceIdModel';
import UserModel from "../../../../utils/models/UserModel";

import CommandButtons from './CommandButtons';
import EventNotActive from './EventNotActive';
import ModalUserRegister from './ModalUserRegister';
import UsersList from './UsersList';

function LeadCollectorConfigurations(props) {

  const location = useLocation();
  const eventId = location.state.idEvent;
  const [isLoading, setIsLoading] = useState(false);
  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [plusXMiceId, setPlusXMiceId] = useState(PlusXMiceIdModel());
  const plusXMiceIdRef = useRef(plusXMiceId);
  useEffect(() => {
    plusXMiceIdRef.current = plusXMiceId;
  }, [plusXMiceId]);
  const [usersList, setUsersList] = React.useState([]);
  const [schedulesList, setSchedulesList] = React.useState([]);
  const [modalUserRegister, setModalUserRegister] = React.useState({
    open: false,
    user: UserModel()
  });
  const [dialogUserControl, setDialogUserControl] = React.useState({
    open: false,
    title: '',
    message: '',
    icon: 'info',
    command: '',
    userId: '',
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      const _plusXMiceId = await plusXMiceIdService.getPlusXMiceId(eventId);
      setPlusXMiceId(_plusXMiceId);

      setTimeout(() => {
        getEventData();
      }, 100);

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, []);

  const getEventData = React.useCallback(async () => {
    try {
      if (!plusXMiceIdRef.current.active) {
        return;
      }

      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      const _token = await adminUserService.getAdminTokenApi(plusXMiceIdRef.current.miceId);

      let _users = await adminUserService.getEventUsersApi(_token, plusXMiceIdRef.current.miceId);
      setUsersList(_users);

      let _schedules = await scheduleService.getSchedulesHallApi(plusXMiceIdRef.current.miceId);
      setSchedulesList(_schedules);

    } catch (error) {
      console.log('Error getEventData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, [plusXMiceId, plusXMiceIdRef]);

  const closeModalUserRegister = React.useCallback(() => {
    setModalUserRegister({
      open: false,
      user: UserModel()
    });
  }, [modalUserRegister]);

  const openNewUser = React.useCallback(() => {
    setModalUserRegister({
      open: true,
      user: UserModel()
    });
  }, [modalUserRegister]);

  const openEditUser = React.useCallback((user = UserModel()) => {
    setModalUserRegister({
      open: true,
      user: user
    });
  }, [modalUserRegister]);

  const openCopyUser = React.useCallback((user = UserModel()) => {
    let _user = { ...user };
    _user.ID = '';
    setModalUserRegister({
      open: true,
      user: _user
    });
  }, [modalUserRegister]);

  const openDialogDeleteUser = React.useCallback(async (user = UserModel()) => {
    setDialogUserControl({
      ...dialogUserControl,
      open: true,
      title: 'Atençao',
      message: `Tem certeza que deseja deletar o usuário '${user.Nome}'.`,
      icon: 'danger',
      command: 'delete',
      userId: user.ID,
    });
  }, [dialogUserControl]);

  const tryDeleteUser = React.useCallback(async () => {
    try {
      setLoadingControl({ message: 'Deletando', open: true });

      const _token = await adminUserService.getAdminTokenApi(plusXMiceIdRef.current.miceId);

      let _user = usersList.find(u => { return u.ID === dialogUserControl.userId });
      await adminUserService.deleteEventUserApi(_token, _user.ID);

      setDialogUserControl({ ...dialogUserControl, open: false, icon: 'info' });

      let _usersList = usersList.filter(u => { return u.ID !== _user.ID });
      setUsersList(_usersList);

      setAlertControl({
        open: true,
        title: '',
        message: 'Usuário deletado com sucesso',
        icon: 'success'
      });
    } catch (error) {
      console.log('Error tryDeleteUser', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, [loadingControl, alertControl, usersList, dialogUserControl]);

  const trySaveUser = React.useCallback(async () => {
    try {
      setLoadingControl({ message: 'Salvando', open: true });

      let _errorMessage = validateForm();
      if (_errorMessage) {
        setAlertControl({
          open: true,
          title: 'Erro',
          message: _errorMessage,
          icon: 'error'
        });
        return;
      }

      const _token = await adminUserService.getAdminTokenApi(plusXMiceIdRef.current.miceId);

      if (!modalUserRegister.user.ID) {
        let _user = await adminUserService.setEventUserApi(
          _token,
          plusXMiceIdRef.current.miceId,
          modalUserRegister.user,
        );

        let _users = [...usersList, _user];
        setUsersList(_users);
      } else {
        let _user = await adminUserService.updateEventUserApi(
          _token,
          plusXMiceIdRef.current.miceId,
          modalUserRegister.user,
        );

        let _index = usersList.findIndex(u => { return u.ID === _user.ID });
        let _users = [...usersList];
        _users[_index] = _user;
        setUsersList(_users);
      }

      closeModalUserRegister();

      setAlertControl({
        open: true,
        title: '',
        message: 'Usuário salvo com sucesso',
        icon: 'success'
      });

    } catch (error) {
      console.log('Error trySaveUser', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    function validateForm() {
      try {
        if (!modalUserRegister.user.Login) {
          return `Campo 'Login' Obrigatório`;
        }
        if (modalUserRegister.user.Login && usersList.length > 0) {
          for (let index = 0; index < usersList.length; index++) {
            const _item = usersList[index];
            if (
              modalUserRegister.user.ID !== _item.ID &&
              modalUserRegister.user.Login.trim() === _item.Login.trim()
            ) {
              return `Login '${modalUserRegister.user.Login}' já está cadastrado`;
            }
          }
        }
        if (!modalUserRegister.user.Nome) {
          return `Campo 'Nome' Obrigatório`;
        }
        if (!modalUserRegister.user.Email) {
          return `Campo 'Email' Obrigatório`;
        }
        if (!modalUserRegister.user.Perfil) {
          return `Campo 'Perfil' Obrigatório`;
        }
        if (modalUserRegister.user.Perfil === 'staff' && !modalUserRegister.user.PerfilProgramacao) {
          return `Campo 'Programação' Obrigatório`;
        }
        if (!modalUserRegister.user.Senha) {
          return `Campo 'Senha' Obrigatório`;
        }

      } catch (error) {
        console.log('Error validateForm', error);
        throw error;
      }
    }
  }, [loadingControl, alertControl, modalUserRegister, usersList]);

  return (
    <div>
      {!plusXMiceId.active && (
        <EventNotActive />
      )}
      {!modalUserRegister.open && plusXMiceId.active && (
        <>
          <CommandButtons
            openNewUser={openNewUser}
          />
          <UsersList
            usersList={usersList}
            openEditUser={openEditUser}
            openCopyUser={openCopyUser}
            openDialogDeleteUser={openDialogDeleteUser}
          />
        </>
      )}
      {modalUserRegister.open && plusXMiceId.active && (
        <ModalUserRegister
          modalUserRegister={modalUserRegister}
          setModalUserRegister={setModalUserRegister}
          closeModalUserRegister={closeModalUserRegister}
          schedulesList={schedulesList}
          trySaveUser={trySaveUser}
          eventId={plusXMiceIdRef.current.miceId}
        />
      )}

      <Loading loadingControl={loadingControl} />
      <Alert
        alertControl={alertControl}
        setAlertControl={setAlertControl}
      />
      <Dialog
        open={dialogUserControl.open}
        title={dialogUserControl.title}
        message={dialogUserControl.message}
        icon='warning'
        button1OnPress={() => tryDeleteUser()}
        button2OnPress={() => setDialogUserControl({ ...dialogUserControl, open: false, icon: 'info' })}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(LeadCollectorConfigurations);
